import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RRStatusBarModel } from '../../models/status-bar.model';

@Component({
  selector: 'rr-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
})
export class StatusBarComponent implements OnChanges {
  @Input() steps: RRStatusBarModel[] = [];
  public className = '';
  public orderedList = [];
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['steps']) {
      this.orderedList = this.steps.sort((a, b) => {
        return a.order - b.order;
      });
      this.className = 'x' + this.orderedList.length;
      this.orderedList[this.orderedList.length - 1].isLast = true;
      const lastActiveIndex =
        this.orderedList.findIndex((o) => !o.isActive) - 1;
      for (let i = lastActiveIndex; i < this.orderedList.length; i++) {
        if (this.orderedList[i]) this.orderedList[i].isLastActive = true;
      }
    }
  }
}
